import axios from 'axios';
import Cookies from 'js-cookie';
import { setAuthDetails, removeAuthDetails } from '../utils/AuthDetailsUtil';

export const performLogin = ({ params }) => {
  return axios({
    method: 'post',
    url: `/login/`,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const verifyEmailOtp = ({ params }) => {
  return axios({
    method: 'post',
    url: `/login/otp-verify/`,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const verifyResetPasswordEmail = ({ params }) => {
  return axios({
    method: 'post',
    url: '/signup/reset-password-otp/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const verifyResetPasswordOtp = ({ params }) => {
  return axios({
    method: 'post',
    url: '/signup/verify-password-otp/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchAuthToken = async ({ refresh_token }) => {
  var params = {
    refresh: refresh_token,
  }
  const { isTokenValid, access_token } = await isAccessTokenValid();
  if (isTokenValid) {
    return { success: true, access_token };
  }

  return axios({
    method: 'post',
    url: '/token/refresh/',

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    },
    data: params,
  })
    .then(async (response) => {
      let success = false;
      let access_token;

      if (response?.data) {
        const { data = {} } = response;
        access_token = data.access;

        if (access_token && refresh_token) {
          setAuthDetails(access_token, refresh_token);
          success = true;
        }
      }
      return { success, access_token };
    })
    .catch((error) => {
      removeAuthDetails();
      return { success: false, error: error.response }
    });
};

// Check if the token is valid, if yes then retuen the access_token
export const isAccessTokenValid = async () => {
  let isTokenValid = false;

  const refresh_token = localStorage.getItem('refresh_token');
  const token_expiry_date = localStorage.getItem('token_expiry_date');
  const access_token = localStorage.getItem('access_token');

  if (refresh_token && token_expiry_date) {
    const tokenExpiryValidity =
      new Date(token_expiry_date).getTime() - new Date().getTime();

    if (tokenExpiryValidity > 90 * 1000) {
      isTokenValid = true; // Token is going to expire in next 90 seconds
    }
  }

  return { isTokenValid, access_token, refresh_token };
};
